import { alpha } from '@mui/material/styles';
import { blue, white } from '@/lib/colours';

import { Chip, type ChipProps } from '@/primitives';

export interface ToggleChipProps extends ChipProps {
  toggled?: boolean;
}

export function ToggleChip({ toggled, ...props }: ToggleChipProps) {
  return (
    <Chip
      {...props}
      sx={(theme) => ({
        backgroundColor: toggled
          ? blue[600]
          : theme.palette.mode === 'dark'
            ? alpha(blue[400], 0.22)
            : blue[200],
        color: toggled ? white[900] : theme.palette.text.primary,
        '&:hover': {
          backgroundColor: toggled
            ? blue[800]
            : theme.palette.mode === 'dark'
              ? alpha(blue[400], 0.35)
              : blue[400],
          color: white[900],
        },
      })}
    />
  );
}
